import PropTypes from 'prop-types';
import React from 'react';

import Queue from '../../../../queue/QueueContainer';
import config from '../../../../../config';

const TimeTrackReport = ({
  canInstantDownloadCsv,
  startDate,
  endDate,
  dateToString,
}) => (
  <div className="u-text-center">
    <div display-if={!canInstantDownloadCsv}>
      <p className="u-mb-">
        <em>
          CSV exports for date ranges that are bigger than {config.exportReportDays} days are sent via email.
        </em>
      </p>
      <Queue
        display-if={!canInstantDownloadCsv}
        name="reports"
        label="Time track report"
        btnLabel="Export csv to email"
        btnClass="c-btn c-btn--primary"
        jobName="time-track-report"
        filters={{ startDate: dateToString(startDate), endDate: dateToString(endDate) }}
      />
    </div>
  </div>
);

TimeTrackReport.propTypes = {
  canInstantDownloadCsv: PropTypes.bool.isRequired,
  dateToString: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
};

export default TimeTrackReport;
